import { render, staticRenderFns } from "./Chromosomes.vue?vue&type=template&id=badd3f7a&scoped=true&"
import script from "./Chromosomes.vue?vue&type=script&lang=js&"
export * from "./Chromosomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badd3f7a",
  null
  
)

export default component.exports